import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Investments from "@/pages/Investments";
import Watchlist from "@/pages/Watchlist";
import PublicWatchlist from "@/pages/PublicWatchlist";
import Accounts from "@/pages/Accounts";
import Rules from "@/pages/Rules";
import Budgets from "@/pages/Budgets";
import Goals from "@/pages/Goals";
import Trips from "@/pages/Trips";
import DebtsLoansPage from "@/pages/DebtsLoansPage";
import Assistant from "@/pages/Assistant";
import Rebalance from "@/pages/Rebalance";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // If we come back from OAuth with session_id in the hash, handle before other routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/verify" element={<VerifyEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/w/:token" element={<PublicWatchlist />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AppShell><Dashboard /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/investments"
        element={
          <ProtectedRoute>
            <AppShell><Investments /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/watchlist"
        element={
          <ProtectedRoute>
            <AppShell><Watchlist /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounts"
        element={
          <ProtectedRoute>
            <AppShell><Accounts /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/debts"
        element={
          <ProtectedRoute>
            <AppShell><DebtsLoansPage kind="debt" /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/loans"
        element={
          <ProtectedRoute>
            <AppShell><DebtsLoansPage kind="loan" /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rules"
        element={
          <ProtectedRoute>
            <AppShell><Rules /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/budgets"
        element={
          <ProtectedRoute>
            <AppShell><Budgets /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/goals"
        element={
          <ProtectedRoute>
            <AppShell><Goals /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/trips"
        element={
          <ProtectedRoute>
            <AppShell><Trips /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rebalance"
        element={
          <ProtectedRoute>
            <AppShell><Rebalance /></AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/assistant"
        element={
          <ProtectedRoute>
            <AppShell><Assistant /></AppShell>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
